/**
 * MJ 悠船 V7（midjourney）manifest
 * 数据来源：image.json field_map
 * 特点：独占「变化度/风格化/原始模式」三控件；无清晰度、无质量分档；参考图上限 6
 */
import type { ImageModelConfig } from '../../types';

export const mjYouchuanV7: ImageModelConfig = {
  id: '01K8HSN2D5FTJT5QA7P26AG1V4',
  displayName: 'MJ 悠船 V7',
  displayNameKey: 'canvas.image.modelNames.mjYouchuanV7',

  defaults: {
    ratio: '1:1', // 接口 select: true 项
    raw: 0, // 接口 raw.value
    changeDegree: 30, // 接口 change_degree.value
    stylize: 100, // 接口 stylize.value
  },

  ratioOptions: {
    '*': [
      { label: '1:1', value: '1:1' },
      { label: '2:3', value: '2:3' },
      { label: '3:2', value: '3:2' },
      { label: '3:4', value: '3:4' },
      { label: '4:3', value: '4:3' },
      { label: '9:16', value: '9:16' },
      { label: '16:9', value: '16:9' },
      { label: '21:9', value: '21:9' },
    ],
  },

  resolutionOptions: [],
  qualityOptions: [],

  toggles: {
    changeDegree: true, // 变化度滑杆（0~100，step 10）
    stylize: true, // 风格化滑杆（0~1000，step 10）
    raw: true, // 原始模式单选（0=常规 / 1=原始）
  },

  limits: {
    maxRefImages: 6, // 接口 field_map.ref_images.max
  },

  /** 画布扩展（仅画布用到的字段；feed 不消费） */
  canvas: {
    poorInSkillMode: true,
    limits: { promptMaxLength: 1024 },
  },
};
